<template>
  <div>
    <!-- <teleport :to="body"> -->
    <div class="overlay">
      <div class="overlay-right">
        <div class="overlay-right-header">
          <div style="font-weight: bold">任务详情</div>
          <div @click="onClose" style="cursor: pointer">
            <BaseSvg
              style="width: 20px; height: 20px"
              iconClass="close"
            ></BaseSvg>
          </div>
        </div>
        <div
          :style="auditShow ? 'height: calc(100vh - 160px)' : 'height: 100%'"
          class="overlay-right-main"
        >
          <div>
            <div class="rectitle" v-if="isUnqualified">
              <div class="rectitle-text">
                <span style="font-size: 16px; color: #ea0d0d">不可结算</span>
                <span style="font-size: 14px">
                  数据检测不合格，系统已自动拦截
                </span>
              </div>
            </div>
            <!-- 查询结果包含 重复图片的话 展示-->
            <BaseRow
              v-if="isPicRepeat"
              style="padding: 5px 5px; text-align: left"
            >
              <span>
                <i class="el-icon-warning" style="color: #ff4949"></i>
                <span style="font-weight: bold">图片查重提示：</span>
                <span style="color: #ff4949">*</span>
                标记任务记录内提交的图存在重复,
                <BaseButton
                  type="text"
                  @click="repeatPickurePerview"
                  style="color: #409eff; text-decoration: underline"
                >
                  点击查看
                </BaseButton>
              </span>
            </BaseRow>
          </div>
          <div class="overlay-right-main__reuqire">
            <div class="overlay-right-main__reuqire-item">
              <div>终端服务人员：</div>
              <div>
                {{ taskDetail?.username || '-' }}
                <span style="margin: 0 1px"></span>
                {{ taskDetail?.phone || '-' }}
              </div>
            </div>
            <div class="overlay-right-main__reuqire-item">
              <div>任务提交时间：</div>
              <div>{{ formatter.date(taskDetail?.editStatusAt) }}</div>
            </div>
            <div
              v-if="projectType === 19"
              class="overlay-right-main__reuqire-item"
            >
              <div>结算金额：</div>
              <div>{{ formatter.fen2yuan(taskDetail?.price) }}</div>
            </div>
          </div>
          <div class="overlay-right-main__info">
            <div class="overlay-right-main__info-item">
              <BaseButton
                type="primary"
                @click="showPreviewName = 'informationShow'"
                v-if="projectType === 21"
              >
                查看资讯
              </BaseButton>
            </div>
            <p style="margin: 24px 0">问卷详情</p>
            <div>
              <component
                :is="compNames"
                :isShowMapHandleBtn="isShowMapHandleBtn"
                :questionInfo="questionDetailInfo"
                @changeImgUrl="onChangeImgUrl"
                @mapRefresh="onMapRefresh"
                @diffMap="onDiffMap"
              ></component>
            </div>
          </div>
        </div>
        <div
          v-if="auditShow"
          v-resource="['任务记录_审核任务']"
          class="overlay-right-footer"
        >
          <div>
            <BaseButton
              :disabled="
                taskDetail?.buttonOnOff === 0 || taskDetail?.buttonOnOff === 2
              "
              @click="onAudit(2)"
              plain
            >
              通过
            </BaseButton>
            <BaseButton
              :disabled="taskDetail?.buttonOnOff === 0"
              type="default"
              @click="onAudit(3)"
              plain
            >
              不通过
            </BaseButton>
          </div>
        </div>
      </div>
      <div class="overlay-left">
        <CPreview
          v-if="showPreviewName === 'informationShow'"
          :projectType="props.projectType"
          :informationId="taskDetail?.informationId"
          :projectId="props.projectId"
          :taskId="props.id"
        ></CPreview>
        <BaseImageViewer
          v-if="showPreviewName === 'imgViewerShow'"
          :previewTeleported="true"
          :infinite="true"
          :preview-src-list="picList"
          :initial-index="showIndex"
          :hide-close="true"
        ></BaseImageViewer>
        <DeefMap
          v-if="showPreviewName === 'deefMapShow'"
          :projectType="props.projectType"
          :projectId="props.projectId"
          :taskRecordId="props.id"
          :dataState="taskDetail?.dataState"
        ></DeefMap>
      </div>
    </div>
    <!-- </teleport> -->
  </div>
</template>
<script lang="tsx" setup>
import {
  defineProps,
  withDefaults,
  defineEmits,
  watch,
  ref,
  nextTick,
  computed,
  onMounted,
  onUnmounted
} from 'vue';
import { storeToRefs } from 'pinia';
import { BaseSvg } from '@/components/base/base-svg/index';
import { useTaskAudit } from '../hooks/useTaskAudit';
import {
  BaseButton,
  BaseImageViewer,
  BaseRow,
  createDialog
} from 'xrk-components';
import { questionDetailComps } from '../components/question-detail-comps';
import { ProjectType } from '../types';
import { formatter } from '@/utils';
import {
  taskRecordUpdateMap,
  selectSimilartList,
  taskRecordDetail
} from '../data-source/apis';
import DeefMap from './deef-map.vue';
import CPreview from './c-preview.vue';
import RepeatPickure from './repeat-pickure.vue';

import appStore from '@/store';

const props = withDefaults(
  defineProps<{
    id: number;
    dataState: number;
    projectId: number;
    projectType: ProjectType;
    searchVal: any;
    remove?: () => void;
    canAudit: boolean;
    isShowMapHandleBtn?: boolean; // 是否显示地图操作按钮
  }>(),
  {
    isShowMapHandleBtn: true
  }
);

// 工业-1 服务商-2 供应商-3
const { defaultUserFnCode } = storeToRefs(appStore.useUserStoreSetup);

/**
 * 是否是服务商
 */
const isAsp = computed(() => defaultUserFnCode.value === 2);
/**
 * 是否是工业
 */
// const isIndustry = computed(() => defaultUserFnCode.value === 1);

const isUnqualified = computed(
  () =>
    taskDetail.value?.dataState == 0 &&
    taskDetail.value?.isOverdue == 0 &&
    +taskDetail.value?.superviseStatus !== 1
); // 数据检测不合格，系统拦截);

const repitImgIds = ref([]); // 重复图片id集合
const repitImgList = ref({}); // 重复图片

const showPreviewName = ref(
  props.projectType === 17 ? 'informationShow' : 'imgViewerShow'
);

const isPicRepeat = computed(() => {
  return !!Object.keys(repitImgIds.value).length;
});
const getRepitImgList = async () => {
  const { data } = await selectSimilartList({
    projectId: props.projectId,
    taskIdList: [props.id]
  });
  repitImgList.value = data || {};
  repitImgIds.value = Object.keys(repitImgList.value);
};
getRepitImgList();
const repeatPickurePerview = () => {
  createDialog({
    width: 1500,
    title: '图片重复关联项目',
    showClose: true,
    contentRender: () => {
      return (
        <div style="padding: 20px;">
          <RepeatPickure
            projectId={props.projectId}
            taskId={props.id}
            similarTaskIdList={repitImgList.value[props.id]}
          ></RepeatPickure>
        </div>
      );
    },
    beforeConfirm: async done => {
      done();
    }
  });
};

const auditShow = computed(() => {
  return props.canAudit && isAsp.value;
});

const compNames = computed(() => {
  return questionDetailComps(props.projectType);
});

function convertValuesToJsonArray(data: any[]): any[] {
  return data.map(item => {
    try {
      // 尝试将 values 字段解析为 JSON
      const parsedValues = JSON.parse(item.values);
      const parsedOptions = JSON.parse(item.optionJson);

      item.values = parsedValues;
      item.optionJson = parsedOptions;
    } catch (error) {
      // 如果解析失败，保持原样
    }
    return item;
  });
}
const taskDetail = ref<any>({});

const questionDetailInfo = computed(() => {
  return convertValuesToJsonArray(
    taskDetail.value?.questionnaireInFoDTOS || []
  );
});
// const body = document.body;

const showIndex = ref(0);
const emits = defineEmits(['auditOver', 'refresh']);

const onChangeImgUrl = url => {
  // 查找url在于picList
  const index = picList.value.findIndex(item => item === url);
  onChangeActive(index);
  showPreviewName.value = 'imgViewerShow';
};

const onChangeActive = index => {
  showIndex.value = index;
};
const onAudit = async status => {
  useTaskAudit({
    auditStatus: status,
    projectId: props.projectId,
    queryParams: {
      sceneType: props.projectType,
      taskRecordId: [props.id]
    },
    auditOver() {
      emits('auditOver', taskDetail.value?.nextTaskId);
    }
  });
};

const onMapRefresh = async () => {
  await taskRecordUpdateMap({
    taskRecordId: props.id,
    projectId: props.projectId,
    sceneType: props.projectType
  });
  getTaskDetail();
};

const onDiffMap = () => {
  showPreviewName.value = 'deefMapShow';
};

const picList = ref([]); //图片列表

const initPicList = async () => {
  picList.value = [];
  // 协定服务
  if (props.projectType === 19) {
    const imageTypeReg = new RegExp(/\.bmp|\.jpg|\.png|\.gif|\.jpeg/, 'i');

    questionDetailInfo.value[0].values.forEach(item => {
      // item.url 后缀为图片则push
      if (imageTypeReg.test(item.url)) {
        picList.value.push(item.url);
      }
    });
  } else {
    questionDetailInfo.value.forEach(item => {
      if (item.topicType === -3) {
        item.values && picList.value.push(item.values);
      }
      if (item.topicType === 20) {
        item.values && picList.value.push(item.values);
      }

      if (item.topicType === 13) {
        item.values &&
          item.values.forEach(item => {
            picList.value.push(item.url);
          });
      }
      if (item.topicType === 16) {
        item.values &&
          item.values.addressPicUrl &&
          picList.value.push(item.values.addressPicUrl);
      }
    });
  }
  if (props.projectType !== 17 && !picList.value.length) {
    showPreviewName.value = '';
  }
};

watch(
  () => showIndex.value,
  () => {
    showPreviewName.value = '';
    nextTick(() => {
      showPreviewName.value = 'imgViewerShow';
    });
  }
);

const getTaskDetail = async () => {
  const { data } = await taskRecordDetail({
    id: props.id,
    dataState: props.dataState,
    projectId: props.projectId,
    sceneType: props.projectType,
    searchVal: props.searchVal
  });
  taskDetail.value = data;
  initPicList();
};
getTaskDetail();
const onClose = () => {
  props.remove();
};
const handleEsc = event => {
  if (event.key === 'Escape') {
    onClose();
  }
};
onMounted(async () => {
  window.addEventListener('keydown', handleEsc);
});
onUnmounted(() => {
  window.removeEventListener('keydown', handleEsc);
});
</script>
<style lang="scss" scoped>
::v-deep {
  .xrk-image-viewer__mask {
    opacity: 0;
  }
}
.overlay {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 99;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  overflow: auto;
  &-right {
    z-index: 3000;
    position: absolute;
    box-sizing: border-box;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    box-shadow: 0px 16px 48px 16px rgba(0, 0, 0, 0.08),
      0px 12px 32px rgba(0, 0, 0, 0.12), 0px 8px 16px -8px rgba(0, 0, 0, 0.16);
    overflow: hidden;
    width: 25%;
    height: 100%;
    right: 0;
    animation: slip_in 0.3s;
    &-header {
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      color: #72767b;
      display: flex;
      justify-content: space-between;
      padding: 20px 20px 22px 20px;
      border-bottom: 1px solid #c1c1c1;
    }
    &-main {
      height: calc(100vh - 160px);
      position: relative;
      overflow: auto;
      box-sizing: border-box;
      padding: 20px;
      &__reuqire {
        padding-bottom: 24px;
        border-bottom: 1px solid #f0f0f0;
        &-item {
          display: flex;
          align-items: center;
          margin-bottom: 5px;
          justify-content: space-between;
        }
      }
      &__info {
        margin-top: 24px;
      }
    }
    &-footer {
      text-align: right;
      height: 80px;
      background: #fff;
      border-top: 1px solid #c1c1c1;
      width: 100%;
      position: absolute;
      bottom: 0;
      padding: 25px 50px;
    }
  }
  &-left {
    width: 75%;
    height: 100%;
    position: absolute;
    overflow: hidden;
    left: 0;
  }
}

/*右侧滑入*/
@keyframes slip_in {
  from {
    transform: translateX(100%);
  }
  to {
    transform: translateX(0);
  }
}
</style>
